<template>
  <div class="formdomian">
    <el-form :model="domain" label-width="100px">
      <el-form-item label="默认渠道参数">
        <el-input v-model="domain.channel"></el-input>
      </el-form-item>
      <el-form-item label="推广开户域名">
        <el-input v-model="domain.acUrl"></el-input>
      </el-form-item>
      <el-form-item label="推广代理域名">
        <el-input v-model="domain.agentUrl"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit()">確認</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Url from '@/views/agent/util/url'
import tablePage from '@/components/page/table'
import Qs from 'qs'
import DateUtil from '@/utils/dataUtil'
import UPDATE from "@/components/page/update";


export default {
  name: 'domainSetting',
  components: {
    UPDATE
  },

  data() {
    return {
      domain: {
        channel: "",
        acUrl: "",
        agentUrl: "",
      }
    }
  },

  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    submit() {
      this.dataChange(Url.adAgent.domainSettingModify, this.domain, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.loadingDomainSetting();
        } else {
          this.$message.error(res.message)
        }
      })
    },

    loadingDomainSetting: function () {
      this.$axios.get(Url.adAgent.domainSettingLoad, {}).then(res => {
        if (res.code == 0) {
          this.domain = res.result;
          console.info(this.domain);
        } else
          this.$message.error(res.message);
      })
    },
  },


  mounted() {
    this.loadingDomainSetting();
  }
}
</script>

<style scoped>
.formdomian
{
  margin: 5%;
}
</style>
